module.exports = __webpack_public_path__ + "media/application/images/2023/shapes/07_shape-sm-a3a249a977e01aa206bcdcaae9429c01.png";